import { render, staticRenderFns } from "./tradeHistory.vue?vue&type=template&id=9f094988"
import script from "./tradeHistory.vue?vue&type=script&lang=js"
export * from "./tradeHistory.vue?vue&type=script&lang=js"
import style0 from "./tradeHistory.vue?vue&type=style&index=0&id=9f094988&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports